import { Outlet } from "react-router";
import { lazy, Suspense } from "react";

import { SplashScreen } from "src/components/loading-screen";


const JobApplicationPage = lazy(() =>
  import('src/sections/human-resources/jobPositions/jobApply/jobApply-list')
);

const JobPortalLayout = lazy(()=> import('src/layouts/job-portal/job-portal-layout'))


export const jobPortalRoute = [
  {
    path: 'humanResources/apply',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'jobs',
        element: (
          <JobPortalLayout>
          <JobApplicationPage/>
          </JobPortalLayout>
        ),
      }, 
    ],
  },
];